import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout';
import { getApiUrl } from './config';

function Customers() {
    const [customers, setCustomers] = useState([]);
    const [newCustomer, setNewCustomer] = useState({ name: '', contact: '', address: '', email: '' });

    useEffect(() => {
        fetchCustomers();
    }, []);

    const fetchCustomers = async () => {
        try {
            const res = await axios.get(`${getApiUrl()}/customers`);
            setCustomers(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const handleAddCustomer = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${getApiUrl()}/customers`, newCustomer);
            setNewCustomer({ name: '', contact: '', address: '', email: '' });
            fetchCustomers();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Layout>
            <div className="container mt-4">
                <h2>Customers</h2>
                <form onSubmit={handleAddCustomer} className="mb-4">
                    <div className="row g-3">
                        <div className="col-md-3">
                            <input type="text" className="form-control" placeholder="Customer Name" value={newCustomer.name} onChange={e => setNewCustomer({...newCustomer, name: e.target.value})} onFocus={(e) => e.target.select()} required />
                        </div>
                        <div className="col-md-3">
                            <input type="text" className="form-control" placeholder="Contact" value={newCustomer.contact} onChange={e => setNewCustomer({...newCustomer, contact: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-md-3">
                            <input type="text" className="form-control" placeholder="Address" value={newCustomer.address} onChange={e => setNewCustomer({...newCustomer, address: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-md-3">
                            <input type="email" className="form-control" placeholder="Email" value={newCustomer.email} onChange={e => setNewCustomer({...newCustomer, email: e.target.value})} onFocus={(e) => e.target.select()} />
                        </div>
                        <div className="col-md-1 d-grid">
                            <button type="submit" className="btn btn-primary">Add</button>
                        </div>
                    </div>
                </form>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Contact</th>
                                <th>Address</th>
                                <th>Email</th>
                            </tr>
                        </thead>
                        <tbody>
                            {customers.map(c => (
                                <tr key={c.id}>
                                    <td>{c.name}</td>
                                    <td>{c.contact}</td>
                                    <td>{c.address}</td>
                                    <td>{c.email}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Layout>
    );
}

export default Customers;
